<template>


  <div id="app"  class="flex flex-col h-screen relative">

    <div class="px-8 py-2 bg-brand-blue text-white text-center text-sm">System update completed. Please report any application issues with the new version to your org admin.</div>

    <div v-if="saveError" class="px-8 py-3 bg-red-600 text-white text-center text-sm flex items-center justify-center gap-4">
      <span>{{ saveError }}</span>
      <button class="underline font-semibold" @click="dismissSaveError">Dismiss</button>
    </div>

    <global-header-bar></global-header-bar>

    <div class="w-full relative flex-grow h-2/3" v-if="loaded">
      <router-view/>
    </div>

  </div>
</template>


<style>
#app {
  font-family: Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#sidenav .link {
  @apply block uppercase text-sm tracking-wide px-4 py-3 text-white;
  @apply bg-gray-800;
}

#sidenav .link[data-active="true"]{
  @apply bg-gray-600;
}

.dropdown:hover .options {
  display: block;
}


</style>
<script>
import GlobalHeaderBar from "@/components/GlobalHeaderBar";
import supabase from "@/supabaseClient";

export default {
  components: {GlobalHeaderBar},
  data: function(){
    return {
      loaded: false
    }
  },
  mounted: async function() {

    //console.log(window.location.hash);
    if(window.location.hash.startsWith('#/reset?')){
      this.$store.state.initialized = true;
      this.loaded = true;
      return;
    }

    // Restore the Supabase session so auto-refresh can take over
    const accessToken = localStorage.getItem("token");
    const refreshToken = localStorage.getItem("refreshToken");
    if(accessToken && refreshToken){
      await supabase.auth.setSession({ access_token: accessToken, refresh_token: refreshToken });
    }

    // Keep the Vuex token in sync whenever Supabase silently refreshes it
    supabase.auth.onAuthStateChange((event, session) => {
      if(event === "TOKEN_REFRESHED" && session){
        console.log("token refreshed");
        this.$store.commit("updateToken", session.access_token);
        localStorage.setItem("refreshToken", session.refresh_token);
      } else if(event === "SIGNED_OUT"){
        this.$store.commit("logout");
        this.$router.push({ name: "Login" }).catch(() => {});
      }
    });

    let user = await this.$store.dispatch("authorize");
    console.log("loaded", user);

    this.$store.state.initialized = true;
    this.loaded = true;

    if(!user && (this.$route.name !== "Login")){
      this.$router.push({
        name: "Login"
      }).catch(() => {
        console.log("avoid duplicate route")
      })
    }

  },
  computed: {
    authorized() {
      return this.$store.state.authorized;
    },
    saveError() {
      return this.$store.state.saveError;
    }
  },
  watch: {
    saveError(msg) {
      if(msg){
        this.$router.push({ name: "Login" }).catch(() => {});
      }
    }
  },
  methods: {
    dismissSaveError() {
      this.$store.commit("clearSaveError");
    }
  }
}
</script>